import baseStyles from './base'
import oliveStyles from './olive'
import inkStyles from './ink'

export default {
  base: baseStyles,
  olive: oliveStyles,
  ink: inkStyles,
}
